const getters = {
  getUploadPercent(state) {
    return state.uploadPercent * 100
  }
}

export default getters
